<template>
  <div>
    <v-card
      class="mx-auto mb-5"
      max-width="344"
      @click="goToRoute('temas')"
    >
      <v-img
        src="../../assets/redacao_corrigida.svg"
        height="170px"
      ></v-img>

      <v-card-title>
        Temas
      </v-card-title>

      <v-card-subtitle>
        Aqui você encontra os mais diversos temas para treinar sua escrita de redação
      </v-card-subtitle>
    </v-card>

    <v-card
      class="mx-auto mb-5"
      max-width="344"
      @click="goToRoute('modulos')"
    >
      <v-img
        src="../../assets/redacao_rascunho.svg"
        height="170px"
      ></v-img>

      <v-card-title>
        Vídeos
      </v-card-title>

      <v-card-subtitle>
        Você encontra nossos módulos e vídeos organizados
      </v-card-subtitle>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="344"
      @click="goToRoute('redacao')"
    >
      <v-img
        src="../../assets/redacao_pendente.svg"
        height="170px"
      ></v-img>

      <v-card-title>
        Redações
      </v-card-title>

      <v-card-subtitle>
        Você verá as sua redações corrigidas, pendentes e que estão em rascunho
      </v-card-subtitle>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Essay',
  methods: {
    goToRoute (path) {
      this.$router.push(path)
    }
  }
}
</script>
